module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst icon = model.icon || ''\nconst colors = model.colors || {}\nconst color = colors.activeFG\nconst backgroundColor = colors.activeBG\nconst borderColor = colors.bar\nconst additionalStyles = []\nif(color)           additionalStyles.push(`--fec-mainTabAlias-fg-color: ${color};`);\nif(backgroundColor) additionalStyles.push(`--fec-mainTabAlias-bg-color: ${backgroundColor};`);\nif(borderColor)     additionalStyles.push(`--fec-mainTabAlias-border-color: ${borderColor};`);\n%><div style=\"<%- additionalStyles.join(' '); %>\">\n<i class=\"<%- icon %>\"></i>\n</div>"
  , __filename = "components/templates/core/tabStrip/mainTabAlias.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const icon = model.icon || ''
const colors = model.colors || {}
const color = colors.activeFG
const backgroundColor = colors.activeBG
const borderColor = colors.bar
const additionalStyles = []
if(color)           additionalStyles.push(`--fec-mainTabAlias-fg-color: ${color};`);
if(backgroundColor) additionalStyles.push(`--fec-mainTabAlias-bg-color: ${backgroundColor};`);
if(borderColor)     additionalStyles.push(`--fec-mainTabAlias-border-color: ${borderColor};`);

    ; __line = 11
    ; __append("<div style=\"")
    ; __append( additionalStyles.join(' ') )
    ; __append("\">\n<i class=\"")
    ; __line = 12
    ; __append( icon )
    ; __append("\"></i>\n</div>")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/tabStrip/mainTabAlias.ejs

}